import { v4 as uuidv4 } from 'uuid';
import { ITEM_TYPES, WELL_TYPES } from './PicabooConstants';
import { GraphicItemUtils } from '../utils/GraphicItemUtils';

export class BackgroundImageToPageItemAdapter {
  constructor(background, page, dim) {
    const ratioBase = page.ratioBase || page.get('ratioBase');

    this.itemType = ITEM_TYPES.GRAPHICITEM;
    this.id = uuidv4().toUpperCase();
    this.type = WELL_TYPES.NORMAL;
    this.imageID = background.imageID || background.id;
    this.positionX = 0;
    this.positionY = 0;
    this.width = ratioBase;
    this.height = page.ratio || page.get('ratio');
    this.rotation = 0;
    this.image_rotation = 0;
    this.image_orientation = 0;
    this.pageID = page.id || page.get('id');
    this.maskShape = '';
    this.filters = [];

    let fit = GraphicItemUtils.fitImage(
      background.width || background.imageWidth,
      background.height || background.imageHeight,
      dim.width,
      dim.height,
    );
    let imgWidth = (fit.width / dim.width) * ratioBase;
    let imgHeight = (fit.height / dim.width) * ratioBase;

    this.image_width = imgWidth;
    this.image_height = imgHeight;
    this.image_positionX =
      ((fit.width - dim.width) / 2 / dim.width) * -1 * ratioBase;
    this.image_positionY =
      ((fit.height - dim.height) / 2 / dim.width) * -1 * ratioBase;
  }
}
